import { RouteComponentProps } from "@reach/router";
import { Layout } from "../../components/Layout";
import { Sidebar } from "../../components/Sidebar";

export const Clients: React.FC<RouteComponentProps> = () => (
    <Layout sidebar={() => <Sidebar />}>Clients page</Layout>
);